import React from 'react'
import { Box, Skeleton, useMediaQuery, useTheme } from '@mui/material'

export const BarChartSkeleton = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box sx={{ 
      height: '100%', 
      width: '100%',
      p: 2
    }}>
      <Box sx={{ height: 'calc(100% - 40px)', position: 'relative' }}>
        <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'end', height: { xs: '150px', md: '200px' }, gap: 1 }}>
            {[...Array(isMobile ? 8 : 12)].map((_, index) => (
              <Box key={index} sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'end' }}>
                <Skeleton 
                  variant="rectangular" 
                  width="80%" 
                  height={`${Math.random() * 70 + 30}%`} 
                  sx={{ borderRadius: '2px 2px 0 0' }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
        {[...Array(isMobile ? 4 : 6)].map((_, index) => (
          <Skeleton key={index} variant="text" width={40} height={16} />
        ))}
      </Box>
    </Box>
  )
}